<template>
	<div
    class="filter-dropdown"
    :class="{'filter-dropdown--active': showOptionsList}"
    ref="filterDropdown"
  >
		<button
      type="button"
      class="filter-dropdown_opener caption-2"
      @click="dropDownToggle"
    >
			{{ options.name[lang] }}
      <i
        class="icons"
        :class="showOptionsList ? 'icons-chevron-up' : 'icons-chevron-down'"
      >
      </i>
		</button>
    <ul
      class="filter-dropdown_list"
      :class="{'filter-dropdown_list--to-left': showFiltersToLeft}"
    >
      <li
        class="filter-dropdown_item"
        v-for="(opt, index) in options.filterGroup.filters"
        :key="index"
      >
        <label class="checkbox">
          <input
            type="checkbox"
            :value="opt.key"
            v-model="selectedFiltersTemp"
            :key="`input-${index}`"
          />
          <span class="checkmark"></span>
          {{ opt.value[lang] }}
        </label>
      </li>
      <li class="filter-dropdown_item--footer">
        <md-button
          class="md-primary md-button-large button text-btn rest reset-btn"
          :class="{'reset-btn--show': showResetBtn}"
          @click="clearSelected"
        >
          Reset
        </md-button>
        <md-button
          class="md-primary md-button-large md-raised button"
          @click="applyFilters"
        >
          Save
        </md-button>
      </li>
    </ul>
	</div>
</template>

<script>
export default {
	name: 'FiltersDropdown',
	props: {
		options: { type: Object },
    selectedFilters: { type: Array },
	},
  created() {
	  this.resetNewFilters();
  },
  beforeDestroy() {
	  this.removeClickOutside();
  },
  data: () => ({
		isOpen: false,
    showFiltersToLeft: false,
    selectedFiltersTemp: [],
	}),
	computed: {
		lang() {
			return this.$store.state.LANG || 'enUS';
		},
    showResetBtn() {
		  return this.selectedFiltersTemp.length;
    },
    showOptionsList() {
		  return this.isOpen;
    }
	},
	methods: {
	  resetNewFilters() {
      this.selectedFiltersTemp = this.selectedFilters;
    },
    updateFilters(arrFilter) {
      this.$emit('update-filter', {
        filterGroupKey: this.options.key,
        filterSelect: arrFilter,
      });
    },
    clearSelected() {
      this.updateFilters([]);
      this.$nextTick(() => this.resetNewFilters());
    },
    applyFilters() {
      this.updateFilters(this.selectedFiltersTemp);
      this.$nextTick(() => this.dropDownClose());
    },
    calcListPosition() {
      const { width: windowWidth } = document.body.getBoundingClientRect();
      const { left: positionList } = this.$refs.filterDropdown.getBoundingClientRect();
      this.showFiltersToLeft = (windowWidth / 2) < positionList;
    },
		dropDownOpen() {
			this.calcListPosition();
      this.isOpen = true;
      this.$nextTick(() => this.initClickOutside());
		},
    dropDownClose() {
      this.resetNewFilters();
      this.isOpen = false;
      this.removeClickOutside();
    },
    dropDownToggle() {
      this.isOpen ? this.dropDownClose() : this.dropDownOpen();
		},
    initClickOutside() {
      document.addEventListener('click', this.clickOutside);
    },
    clickOutside(ctx) {
      if(!ctx.path.includes(this.$refs.filterDropdown)) this.dropDownClose();
    },
    removeClickOutside() {
      document.removeEventListener('click', this.clickOutside);
    }
	},
};
</script>

<style lang="scss" scoped>
.filter-dropdown {
  position: relative;
}
$opener-gap: 10px;
.filter-dropdown_opener {
  border: 1px solid;
  border-radius: 8px;
  background: #fff;
  padding: 4px 7px;
  display: flex;
  align-items: center;
  gap: $opener-gap;
  white-space: nowrap;
  .filter-dropdown--active & {
    color: $color-blue;
    box-shadow: 0 0 0 1px;
  }
  @supports not (gap: 1px) {
    .icons {
      margin-left: $opener-gap;
    }
  }
}
.filter-dropdown_list {
  list-style: none;
  position: fixed;
  background: $white;
  padding: 10px 0;
  margin: 0;
  min-width: 320px;
  box-shadow: 0 8px 16px rgba(8, 35, 48, .2);
  border-radius: 4px;
  left: 16px;
  right: 16px;
  opacity: 0;
  visibility: hidden;
  transition: opacity .3s ease;
  @media (min-width: $mobile) {
    position: absolute;
    left: 0;
    right: auto;
    z-index: 1;
  }
  .filter-dropdown--active & {
    opacity: 1;
    visibility: visible;
  }
}
.filter-dropdown_list--to-left {
  @media (min-width: $mobile) {
    left: auto;
    right: 0;
  }
}
.filter-dropdown_item {
  padding: 12.5px 27px;
  .checkbox .checkmark {
    margin-right: 23px;
  }
}
.filter-dropdown_item--footer {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  border-top: 1px solid $color-light-grey;
  padding: 8px 15px 0;
  margin-top: 6px;
  @supports not (gap: 1px) {
    .button + .button {
      margin-left: 15px;
    }
  }
}
.reset-btn {
  opacity: 0;
  transform: translateX(100%);
  transition: opacity .3s, transition .3s;
}
.reset-btn--show {
  opacity: 1;
  transform: translateX(0);
}
</style>
